export const blurActiveElement = (delay?: boolean) => {
  const blur = () => (document.activeElement as HTMLElement).blur();

  if (delay) {
    setTimeout(blur, 0);
    return;
  }

  blur();
};
